import React from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import articleImg from "../../assets/article6.png"
import ArticleContent from "../../components/sections/blog/ArticleContent";
import { articleContent6 } from "../../constants/data";
import RequestDemo from "../../components/common/RequestDemo";

const ArticleFourth = ({title, description }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-[2.25rem] sm:gap-16 lg:gap-0">
      <HeroReuse
        Title="Why Missed License Renewals Still Happen (And How to Stop Them)"
        Description="Missed license renewals can lead to penalties, downtime, and lost trust. Learn the real reasons teams still miss deadlines and how better license management and automation can stop it."
        date="10 July 2025"
        imgUrl={articleImg}
        titleClass={'tracking-tight pt-3 md:pt-8'}
      />
      <ArticleContent content={articleContent6} toolsClass="font-bold text-darkGray"/>
      <RequestDemo />
    </div>
  );
};

export default ArticleFourth;
